import {
  SALESHISTORY_LOADING,
  GET_SALESHISTORY,
  GET_SALESHISTORY_SUCCESS,
  GET_SALESHISTORY_FAIL,
  ADD_SALESHISTORY_SUCCESS,
  ADD_SALESHISTORY_FAIL,
  DELETE_SALESHISTORY_SUCCESS,
  DELETE_SALESHISTORY_FAIL,
  UPDATE_SALESHISTORY_SUCCESS,
  UPDATE_SALESHISTORY_FAIL,
  SALESHISTORY_RESET
} from "./actionType";

const INIT_STATE = {
  salesHistories: [],
  error: {},
};

const SalesHistory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALESHISTORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALESHISTORY:
          return {
            ...state,
            salesHistories: action.payload.data,
            isSalesHistoryCreated: false,
            isSalesHistorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALESHISTORY_FAIL:
      switch (action.payload.actionType) {
        case GET_SALESHISTORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesHistoryCreated: false,
            isSalesHistorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALESHISTORY: {
      return {
        ...state,
        isSalesHistoryCreated: false,
        loading: true,
      };
    }

    case SALESHISTORY_LOADING: {
      return {
        ...state,
        isSalesHistoryCreated: false,
        loading: true,
      };
    }

    case ADD_SALESHISTORY_SUCCESS:
      return {
        ...state,
        isSalesHistoryCreated: true,
        loading: false,
        salesHistories: [action.payload.data, ...state.salesHistories],
      };

    case ADD_SALESHISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SALESHISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesHistoryCreated: true,
        salesHistories: state.salesHistories.filter(
          salesHistory => salesHistory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALESHISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALESHISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesHistoryCreated: true,
        salesHistories: state.salesHistories.map(salesHistory =>
          salesHistory.id.toString() === action.payload.data.id.toString() ? { ...salesHistory, ...action.payload.data } : salesHistory
        ),
      };

    case UPDATE_SALESHISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SALESHISTORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesHistory;